import { useEffect, useCallback } from "react";
import { useNetworkWithFlags } from "./networkHook";
import { useDispatch } from "react-redux";

export default function useNetworkEffect(body, deps) {
    const dispatch = useDispatch();
    const network = useNetworkWithFlags(dispatch);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const bodyPrime = useCallback(body, deps ?? [])
    
    useEffect(() => {
        const flags = { ignore: false };
        bodyPrime(network(flags))
        return () => {
            flags.ignore = true;
        }
    }, [network, bodyPrime]);
}